
'use strict';

angular.module('atex.dam').directive('damAuthorsList', [ 'DamAuthorService','$translate', '$timeout', function (DamAuthorService,$translate,$timeout) {
  return {
    scope: {
      'authors': '=',
      'placeHolder': '=',
      'useEvents': '=',
      'useOperator': '='
    },

    controller: function ($scope) {
      $scope.authors = $scope.authors || [];

      $scope.selectPlaceHolder = $scope.placeHolder || '_AUTHORS_';
      $scope._useEvents = $scope.useEvents || false;
      $scope.maxRows = 20;

      $scope.searchAuthors = function(options) {
        return DamAuthorService.searchAuthors(options).then(function (response) {
          return _.extend(response, {
            authors: [],
            tags: response.authors.map(function(author) {
              return {
                id: author.id,
                text: author.aspects.contentData.data.fullName || author.aspects.contentData.data.name,
                type: "user"
              };
            })
          });
        });
      };
    },

    link: function (scope, element, attrs) {
      function format(tag) {
        if (tag.type === 'group') {
          return "<i class='fa fa-group'></i>&nbsp;" + tag.text;
        } else if (tag.type === 'user') {
          return "<i class='fa fa-user'></i>&nbsp;" + tag.text;
        } else if (scope._allowNewUsers) {
          return "<i class='fa fa-user'></i>&nbsp;" + tag.text;
        }
      }

      function toJson(_string, json) {
        json = (!json) ? {} : json;

        if (_string) {
          var properties = _string.split(";") || [];
          _.each(properties, function (property) {
            var split = property.split(":");
            json[split[0].trim()] = split[1].trim();
          });
        }
        return json;
      }

      element.attr('title', attrs.title);

      $(element).select2({
        placeholder: $translate.getTranslationTable()[scope.selectPlaceHolder],
        formatResult: format,
        formatSelection: format,
        tags: function () {
          return [];
        },
        formatNoMatches: function (term) {
          return '';
        },
        containerCss: toJson(attrs.style,{"width":"100%"}),
        query: _.debounce(function(query) {
          var options = {
            filter: query.term,
            maxRows: scope.maxRows,
            start: Math.max(0, ((query.page || 1) - 1)) * scope.maxRows
          };
          scope.searchAuthors(options).then(function(response) {
            var canLoadMore = (response.tags.length > 0) && (response.numFound > response.tags.length);
            return query.callback({ more: canLoadMore, results: response.tags });
          }).then(undefined, function(error) {
            console.log(error);
            return query.callback({ more: false, results: [] });
          });
        }, 200),
        initSelection: _.debounce(function(element, callback) {
          // this method will be called when the dialog is initialized with some already selected authors
          if (scope.authors.length > 0) {
            // we need to copy the existing array because it will be cleared by the 'change' event.
            var authors = angular.copy(scope.authors);

            // build a query containing all the existing selected authors.
            var q = '';
            authors.forEach(function(id) {
              if (q) {
                q += ' OR ';
              }
              q += 'id:"' + id + '"';
            });

            // search the authors and give back all the results.
            return scope.searchAuthors({ query: q, maxRows: authors.length }).then(function(response) {
              // calculate, based on the results, the new list of selected authors (hopefully all of them).
              var selectedAuthors = response.tags.map(function(tag) { return tag.id; });
              // add all the authors result.
              callback(response.tags);
              // make sure the selected authors will be saved in our query.
              $timeout(function() {
                scope.authors = selectedAuthors;
              });
            });
          }

        })
      });

      element.on('select2-open', function () {
        if(scope._useEvents) {
          atex.dam.AngularUtils.width(element, 0);
          atex.dam.AngularUtils.getNode(element, '.input-group-addon').hide();

          var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
          $(node).css('border-radius', '4px 4px 0 0');
          if(scope.useOperator) {
            $(node).css('border-right', '1px solid #5897fb');
            $(node).css('box-shadow', 'none');
          }

          var width = atex.dam.AngularUtils.getWidth(element);
          $('.select2-drop-active').width(width - 2);
        }
      });

      element.on('select2-close', function () {
        if(scope._useEvents) {
          atex.dam.AngularUtils.getNode(element, '.input-group-addon').show();

          var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
          if(scope.useOperator) {
            $(node).css('border-radius', '4px 0 0 4px');
            $(node).css('border-right', 'none');
          } else {
            $(node).css('border-radius', '4px');
            $(node).css('border-right', '1px solid #aaa;');
          }

          var width = atex.dam.AngularUtils.getWidth(element);
          $('.select2-drop-active').width(width + 2);
        }
      });

      element.on('change', function (event) {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        if ($.isArray(objects)) {
          objects.forEach(function (object) {
            values.push(object.id);
          });
        } else {
          values.push(objects.id);
        }

        $timeout(function () {
          scope.authors = values;
        });

      });

      scope.$on('dam:clearAdvancedFields', function () {
        scope.authors = [];
        element.select2('val', null).trigger('change');
      });

      // when editing a saved query the scope.authors will contain the authors (the authors id) that needs to be
      // selected, even if the dropdown is empty, this will force the initSelection method to be called AND the
      // change event to be fired which will clear out the scope.authors variable (because the elements will not
      // exist yet).
      if (scope.authors.length > 0) {
        element.select2('val', scope.authors).trigger('change');
      }

    }
  };
}]);